import reportByVersion from "../../../../Reports/utils/reportVersions";

import React, { Fragment } from "react";


import LoneWorkerONR from "../loneWorker";
import SafetyWatchONR from "../safetyWatch";

const JobBriefingSITE = (props) => {
  const { ptype, towork, tsafwat } = props.data;
  const JobBriefingSITEschema = reportByVersion(props.ver, "onrSITEJobBriefing");
  return (
    <Fragment>
      <JobBriefingSITEschema {...props} />
      {ptype === "LONE WORKER" ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {ptype === "SAFETY WATCH" ? <SafetyWatchONR {...props} MERGED={true} /> : null}
      {/* for new reports where all options are mutually exclusive */}
      {towork === true ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {tsafwat === true ? <SafetyWatchONR {...props} MERGED={true} /> : null}
    </Fragment>
  );
};

export default JobBriefingSITE;



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingSITE/JobBriefingSITE.jsx